import { render, staticRenderFns } from "./RegistroElementos.vue?vue&type=template&id=7bbeef1f&scoped=true"
import script from "./RegistroElementos.vue?vue&type=script&lang=js"
export * from "./RegistroElementos.vue?vue&type=script&lang=js"
import style0 from "./RegistroElementos.vue?vue&type=style&index=0&id=7bbeef1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbeef1f",
  null
  
)

export default component.exports